<script lang="ts">
  /*
   * Los ajustes globales usan módulos con runas: importarlos permite reaccionar a los
   * cambios sin añadir proveedores al árbol. El contexto se reserva para datos con varias
   * instancias, como cada constructor de aplicación.
   */
  import "./lib/fontSize.svelte";
  import "./lib/panelPalette.svelte";
  import "./lib/theme.svelte";

  import GuideTour from "./components/guide/GuideTour.svelte";
  import Router from "./components/Router.svelte";
  import TooltipLayer from "./components/TooltipLayer.svelte";
  import type { RouteDef } from "./lib/router.svelte";
  import Home from "./routes/Home.svelte";
  import LegacyRedirect from "./routes/LegacyRedirect.svelte";
  import Login from "./routes/Login.svelte";
  import Published from "./routes/Published.svelte";
  import Root from "./routes/Root.svelte";

  /*
   * Tres zonas: `/` es el directorio, `/admin/*` el panel y `/<enlace>` cada
   * aplicación publicada (ver `shared/appPaths.ts`). El router dibuja la
   * primera ruta que encaja, así que las de la aplicación van al final: un
   * enlace nunca es un nombre reservado y no le quita la dirección a nadie.
   */
  const routes: RouteDef[] = [
    { path: "/", component: Root },
    { path: "/admin/entrar", component: Login },
    { path: "/admin", component: Home, guarded: true },
    // Cada pestaña de los ajustes tiene su dirección (`/admin/ajustes/general`,
    // `/admin/ajustes/ia`…); `/admin/ajustes` a secas abre la primera.
    { path: "/admin/ajustes/*", load: () => import("./routes/AiSettings.svelte"), guarded: true },
    // La demo del sistema de estilos: no es del producto y no enseña datos de
    // nadie --todo lo suyo es de ejemplo, el pie del sidebar incluido-- así
    // que se entra sin sesión. Se llega desde ajustes o por la dirección.
    // Viene en su propio archivo: lleva Chart.js entero para sus ejemplos, y
    // sin esto lo descargaba todo el que abría cualquier pantalla.
    { path: "/admin/demo", load: () => import("./routes/Demo.svelte") },
    // El constructor se queda con todo lo que cuelgue de la aplicación: sus dos
    // mitades y las capas que se abren encima. Ver `Builder.svelte`.
    //
    // También en su propio archivo: quien abre una aplicación publicada no
    // necesita la cuadrícula ni el panel de la IA. `Home` lo pide por
    // adelantado, que es desde donde se entra.
    { path: "/admin/a/:appId/*", load: () => import("./routes/Builder.svelte"), guarded: true },
    // Las direcciones de antes del prefijo `/admin` siguen abriendo lo mismo.
    { path: "/p/*", component: LegacyRedirect },
    { path: "/a/*", component: LegacyRedirect },
    { path: "/ajustes/*", component: LegacyRedirect },
    { path: "/entrar", component: LegacyRedirect },
    { path: "/demo", component: LegacyRedirect },
    { path: "/directorio", component: LegacyRedirect },
    // Apps publicadas: no necesitan la sesión del panel.
    { path: "/:slug", component: Published },
    { path: "/:slug/:pageSlug", component: Published },
  ];
</script>

<Router {routes} fallback="/" />

<!-- Una sola capa para todos los globos de ayuda del panel. -->
<TooltipLayer />

<!--
  La guía de bienvenida. Va aquí y no en el constructor porque la piden dos
  sitios de rutas distintas: la primera entrada a una aplicación y los ajustes
  de la cuenta. Cerrada no dibuja nada.
-->
<GuideTour />
